import React from "react";
import {Field} from "formik";
import {Password} from "primereact/password";

export default function NsFieldPassword({
                                        name,
                                        value = '',
                                        placeholder = '',
                                        formikRef,
                                        onChange = () => {
                                        },
                                        readOnly = false,
                                        isDisabled = false,
                                        isRequired = false,
                                        validate = () => {
                                        },
                                        isFormFieldInvalid,
                                        translate,
                                        passwordShowFeedback,
                                        passwordFooter,
                                    }) {

    return (
        formikRef && typeof formikRef !== "undefined" ?
            <Field
                name={name}
                component={Password}
                className={"w-100"}
                onChange={(e) => {
                    if (formikRef) {
                        formikRef.current.setFieldValue(name, e.target.value);
                    }
                    onChange(e);
                }}
                pt={{
                    // inconfield è il parent di input quindi devo passare w-100 ad entrambi
                    iconField: {root: {className: 'w-100'}},
                    input: { className: 'w-100' },
                    // trucco per non far sforare il pannello con suggerimenti password
                    panel: { style: {maxWidth: '1px'} },
                    showIcon: { className: 'passwordIconCenterVert' },
                    hideIcon: { className: 'passwordIconCenterVert' }
                }}
                readOnly={readOnly}
                required={isRequired}
                disabled={isDisabled}
                value={value}
                placeholder={placeholder}
                validate={validate}
                invalid={isFormFieldInvalid()}
                toggleMask
                feedback={passwordShowFeedback}
                promptLabel={translate("Inserisci una password")}
                weakLabel={translate("Debole")}
                mediumLabel={translate("Media")}
                strongLabel={translate("Forte")}
                footer={passwordFooter}
            />
            :
            <Password
                name={name}
                className={"w-100"}
                onChange={(e) => {
                    if (formikRef) {
                        formikRef.current.setFieldValue(name, e.target.value);
                    }
                    onChange(e);
                }}
                pt={{
                    // inconfield è il parent di input quindi devo passare w-100 ad entrambi
                    iconField: {root: {className: 'w-100'}},
                    input: { className: 'w-100' },
                    // trucco per non far sforare il pannello con suggerimenti password
                    panel: { style: {maxWidth: '1px'} },
                    showIcon: { className: 'passwordIconCenterVert' },
                    hideIcon: { className: 'passwordIconCenterVert' }
                }}
                readOnly={readOnly}
                required={isRequired}
                disabled={isDisabled}
                value={value}
                placeholder={placeholder}
                invalid={isFormFieldInvalid()}
                toggleMask
                feedback={passwordShowFeedback}
                promptLabel={translate("Inserisci una password")}
                weakLabel={translate("Debole")}
                mediumLabel={translate("Media")}
                strongLabel={translate("Forte")}
                footer={passwordFooter}
            />
    );
}